import ChallengeListItem from './ChallengeListItem';

export default ChallengeListItem;
